export const visit = (vm, at) => {
at({ "en": { "ui-addon-video-player": { "havingTroubleWithVideoLink": "Having trouble watching this video?", "playButton": "Play" } } });
};